export default __webpack_public_path__ + "static/media/ClosedSeaLogo.0ae72f15.png";